import {apiUrl} from './config.js';

/**
 * 通过服务端代理下载云端文件，避免浏览器直连 OSS 时的签名与跨域问题。
 */
export function downloadCloudFile(fileId: string): void {
  const anchor = document.createElement('a');
  anchor.href = apiUrl(`/api/files/${encodeURIComponent(fileId)}/download`);
  anchor.rel = 'noopener';
  document.body.append(anchor);
  anchor.click();
  anchor.remove();
}
